module.exports = __webpack_public_path__ + "static/Template_colorbase_2-4caf5affe63e32a14d99377d3794dc43.png";